// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"UsersList_contentComponent__2xCQU","extraContent":"UsersList_extraContent__2n0Og","createButton":"UsersList_createButton__3qfZr"};